import styled from "styled-components";

const PlaceholderVideoImage = styled.div`
  background: url(${({ videoID }) =>
      `https://img.youtube.com/vi/${videoID.trim()}/maxresdefault.jpg`})
    center no-repeat;
  background-size: cover;
  padding-bottom: 66.47727272727273%;
  width: 100%;
`;

export default PlaceholderVideoImage;
